import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InstallPrompt from './InstallPrompt';

function getDisplayName(user) {
  if (user?.displayName && String(user.displayName).trim()) return user.displayName;
  if (user?.email) return user.email.split('@')[0];
  return 'Usuario';
}

function Header({ user, onLogout }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const displayName = getDisplayName(user);
  const initials = String(displayName).trim().charAt(0).toUpperCase();

  useEffect(() => {
    const onClickOutside = (event) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return (
    <header className="header">
      <div className="brand">
        <img src="/logo.png" alt="Logo QueComo" className="brand-logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <div className="brand-text">
          <h1>QueComo</h1>
          <p className="brand-subtitle">Tu elección de menú</p>
        </div>
      </div>
      <div className="header-right">
        <InstallPrompt />
        <div className="user-menu" ref={menuRef}>
          <button className="user-chip user-chip-btn" onClick={() => setMenuOpen((prev) => !prev)}>
            {user?.avatarUrl ? (
              <img src={user.avatarUrl} alt={displayName} className="user-avatar" referrerPolicy="no-referrer" />
            ) : (
              <span className="user-avatar-fallback">{initials}</span>
            )}
            <div className="user-meta">
              <strong>{displayName}</strong>
              <span>{user?.email}</span>
            </div>
            <span className="user-caret">{menuOpen ? '▲' : '▼'}</span>
          </button>
          <div className={`user-dropdown ${menuOpen ? 'open' : ''}`}>
            <button
              className="dropdown-item"
              onClick={() => {
                setMenuOpen(false);
                navigate('/preferencias');
              }}
            >
              Mi perfil
            </button>
            <button
              className="dropdown-item danger"
              onClick={() => {
                setMenuOpen(false);
                onLogout();
              }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
